export default function HSEPolicy() {
    const policyPoints = [
      "To ensure that the health, safety and security responsibilities of all cadres of management and staff are defined.",
      "To communicate openly with all employees and other persons likely to be affected by the operations of the company about the promotion of a safe working environment and safe systems of work.",
      "To inform employees of their duty to act responsibly and to take all reasonable precautions, not only to protect themselves but others from injury, preventable illness, loss or damage to property, which could arise from their actions.",
      "To ensure that all employee receive adequate and suitable training to enable them to perform their duties in a safe and environmentally responsible manner.",
      "To encourage all employees to participate in the continuing improvement of health, safety, environmental and security performance and to recognize that individual responsibility for health and safety cannot be delegated.",
      "To carry out assessments of new and existing operations, annual audits and regular reviews of health and safety performance.",
      "To minimize the production of waste by efficient use of resources, promote the recycling of materials when waste cannot be eliminated and dispose of waste materials in an environmentally responsible manner, thereby reducing pollution of air, water or land to a practicable minimum.",
      "To control safety, health, environmental hazards, and nuisances, which may cause harm or offence to the community.",
      "To monitor and review energy consumption, reduce any unnecessary energy usage and implement energy-efficient practices.",
      "To seek continuous improvement in methods of identifying, assessing and controlling health, safety, security and environmental hazards.",
      "To improve the HSSE awareness level of both staff and sub-contractors involved in our operations.",
    ];
  
    return (
      <section className="py-20 lg:py-32">
        <div className="max-w-[1120px] mx-auto px-6 lg:px-12">
          {/* Red label */}
          <p className="text-[#D8242A] font-medium mb-5">
            Quality Policy and Authority
          </p>
  
          {/* Main heading */}
          <h2 className="lg:text-[31px] font-medium text-[#0A2540] mb-[40px] leading-tight">
            To set standards which ensure compliance with all relevant health, safety, environmental and security regulations and legislative requirements.
          </h2>
  
          {/* Policy points list */}
          <ul className="space-y-2">
            {policyPoints.map((point, index) => (
              <li key={index} className="flex gap-4 text-[#86939F] font-medium text-lg leading-relaxed">
                <span className="text-[#86939F] mt-1.5 flex-shrink-0">•</span>
                <span>{point}</span>
              </li>
            ))}
          </ul>
        </div>
      </section>
    );
  }